import React from 'react'
import ReactAudioPlayer from 'react-audio-player';

import LoadingScreenMobile from './loadingScreen.component';
import Scene from './Scene.component';
import CarStudioUIMobile from './carStudioUI.component';
import ExitBtnMobile from './exit.component';
import TopMenu from './topmenu.component';
import Drag from '../../components/CarStudio/drag.component'
import DragTablets from '../../components/CarStudio/dragTablets.component';
import PDFViewerMenu from '../../components/CarStudio/pdfViewerMenu.component';
import CurrentCarName from './currentCarName.component';
import Sidebar from './sidebar.component';
import Billboards from './billboards.component';
import VideoMobile from './video.component';
import QuotationMobile from './quotation.component';
import VideoText from './../../components/CarStudio/videoText.component';

import song from './../../UI/Music/song.mp3'

import GETWebParams from '../../helpers/GETWebParams';
const params = GETWebParams()

interface Props {
  openCarStudio: boolean,
  currentCarSelected: string,
  isTouchScreen: boolean,
  handleCloseCarStudio: () => void,
}

interface State {
  openLoadingScreen: boolean,
  openScene: boolean,
  turnOffLights: boolean,
  showLigths: boolean,
  showInteriorLights: boolean,
  closeAllMenus: boolean,
  resetAllMenus: boolean,
  counter: number,
  showDrag: boolean,
  showPDF: boolean,
  currentCompleteCar: string,
  currentModelSelected: string,
  currentColorSelected: string,
  openSidebar: boolean,
  currentLoadingPercentage: number,
  currentLoadingInteriorPercentage: number
  isLocale: boolean,
  showInterior: boolean,
  currentSeatSelected: string,
  isMuted: boolean,
  currentBillboardSelected: string,
  showBullets: boolean
  currentSceneSelected: any
  showBulletInterior: any
  showVideo: boolean,
  showVideoText: boolean,
  isVideoOpened: boolean,
  isPlayingAnimation: boolean,
  isQuotationOpened: boolean,
  firstLoadedWebParams: boolean,
  enableAR: boolean,
  download3DModel: boolean,
  enableInternalCotizaGlobally: boolean,
}

class CarStudioContainerMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      openLoadingScreen: false,
      openScene: false,
      turnOffLights: false,
      showLigths: false,
      showInteriorLights: false,
      closeAllMenus: false,
      resetAllMenus: false,
      counter: 0,
      showDrag: false,
      showPDF: false,
      currentCompleteCar: '',
      currentModelSelected: '',
      currentColorSelected: '',
      openSidebar: false,
      isLocale: false,
      currentLoadingPercentage: 0,
      currentLoadingInteriorPercentage: 0,
      showInterior: false,
      currentSeatSelected: 'FL',
      isMuted: false,
      currentBillboardSelected: '',
      showBullets: false,
      currentSceneSelected: {},
      showBulletInterior: false,
      showVideo: false,
      showVideoText: false,
      isVideoOpened: false,
      isPlayingAnimation: false,
      isQuotationOpened: false,
      firstLoadedWebParams: true,
      enableAR: false,
      download3DModel: false,
      enableInternalCotizaGlobally: false,//enable cotiza form, if enabled, no external link will be opened.
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if(this.props.openCarStudio !== prevProps.openCarStudio && this.props.openCarStudio){
      this.setState({
        openLoadingScreen: true,
        resetAllMenus: false
      })
    }
  }

  handleOpenScene = () => {
    this.setState({
      openLoadingScreen: false,
      openScene: true
    })
  }

  handleCloseDrag = () => {
    this.setState({
      showDrag: false
    })
  }

  handleOpenDrag = () => {
    this.setState({
      showDrag: true
    })
  }

  handleCloseAllMenus = () => {
    this.setState({
      closeAllMenus: !this.state.closeAllMenus
    })
  }

  handleCompleteCar = (payload: string) => {
    this.setState({
      currentCompleteCar: payload
    })
  }

  handleChangeColor = (payload: string) => {
    this.setState({
      currentColorSelected: payload
    }, () => {
      this.handleCloseAllMenus()
    })
  }

  handleTurnOffLigths = () => {
    this.setState({
      turnOffLights: !this.state.turnOffLights
    })
  }

  handleShowLigths = (payload: boolean) => {
    this.setState({
      showLigths: payload
    })
  }

  handleShowInteriorLights = (payload: boolean) => {
    this.setState({
      showInteriorLights: payload
    })
  }

  handleOpenSidebar = () => {
    this.setState({
      openSidebar: !this.state.openSidebar
    })
  }

  handleCloseScene = () => {
    this.setState({
      openLoadingScreen: false,
      openScene: false,
      turnOffLights: false,
      counter: 0,
      showDrag: false,
      showPDF: false,
      currentCompleteCar: '',
      currentModelSelected: '',
      currentColorSelected: '',
      openSidebar: false,
      isLocale: false,
      currentLoadingPercentage: 0,
      currentLoadingInteriorPercentage: 0,
      showInterior: false,
      currentSeatSelected: 'FL',
      isMuted: false,
      currentBillboardSelected: '',
      showBullets: false,
      currentSceneSelected: {},
      showBulletInterior: false,
      showVideo: false,
      isVideoOpened: false,
      isPlayingAnimation: false,
      isQuotationOpened: false,
      resetAllMenus: true,
      firstLoadedWebParams: false,
    }, () => {
      this.handleCloseAllMenus()
      this.props.handleCloseCarStudio()
    })
  }

  handleFirstWebParams = (payload: boolean) => {
    this.setState({
      firstLoadedWebParams: payload
    })
  }

  handleShowPDF = (payload: boolean) => {
    this.setState({
      showPDF: payload
    })
  }

  handleIsLocale = () => {
    this.setState({
      isLocale: true
    })
  }

  handleGetLoadPercentage = (payload: number) => {
    this.setState({
      currentLoadingPercentage: payload
    })
  }

  handleChangeSeat = (payload: string) => {
    this.setState({
      currentSeatSelected: payload
    })
  }

  handleLoadInterior = (payload: number) => {
    this.setState({
      currentLoadingInteriorPercentage: payload
    })
  }

  handleShowInterior = (payload: boolean) => {
    this.setState({
      showInterior: payload
    })
  }

  handleMuteSong = () => {
    this.setState({
      isMuted: !this.state.isMuted
    })
  }

  handleSelectBillboard = (payload: string) => {
    this.setState({
      currentBillboardSelected: payload
    })
  }


  handleShowBullets = (payload: boolean) => {
    this.setState({
      showBullets: payload
    }, () => {
      this.handleCloseAllMenus()
    })
  }

  handleShowBulletsInterior = (payload: boolean) => {
    this.setState({
      showBulletInterior: payload
    }, () => {
      this.handleCloseAllMenus()
    })
  }

  handleChangeScene = (payload: any) => {
    this.setState({
      currentSceneSelected: payload
    }, () => {
      this.handleCloseAllMenus()
    })
  }

  handleShowVideo = (payload: boolean) => {
    this.setState({
      showVideo: payload,
      showBulletInterior: false,
      showBullets: false,
      turnOffLights: false
    })
  }

  handleShowVideoText = (payload: boolean) => {
    this.setState({
      showVideoText: payload
    })
  }

  handleIsVideoOpened = (payload: boolean) => {
    this.setState({
      isVideoOpened: payload
    })
  }

  handleIsPlayingAnimation = (payload: boolean) => {
    this.setState({
      isPlayingAnimation: payload
    })
  }

  handleQuotation = (payload: boolean) => {
    this.setState({
      isQuotationOpened: payload
    })
  }

  handleSelectModel = (payload: string) => {
    this.setState({
      currentModelSelected: payload
    })
  }

  handleAR = (payload: boolean) => {
    this.setState({
      enableAR: payload
    })
    setTimeout(() => {
      this.setState({
        enableAR: false
      })
    }, 1000);
  }

  handle3DDownload = (payload: boolean) => {
    this.setState({
      download3DModel: payload
    })
    setTimeout(() => {
      this.setState({
        download3DModel: false
      })
    }, 1000);
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.openCarStudio ? 'car-studio-general-container-mobile fade-in':'car-studio-general-container-mobile fade-out'}>
          {this.state.openScene && params.lite !== "true" ?
            <ReactAudioPlayer
              src={song}
              autoPlay
              controls={false}
              loop
              muted={this.state.isMuted}
              id={"song"}
              volume={0.02}
            />:null
          }
          {
            this.props.openCarStudio ?
            <Scene
              handleOpenScene = {this.handleOpenScene}
              openScene = {this.state.openScene}
              turnOffLights = {this.state.turnOffLights}
              handleCloseAllMenus = {this.handleCloseAllMenus}
              handleCloseDrag = {this.handleCloseDrag}
              counter={this.state.counter}
              currentCompleteCar = {this.state.currentCompleteCar}
              currentColorSelected = {this.state.currentColorSelected}
              isLocale = {this.state.isLocale}
              handleIsLocale = {this.handleIsLocale}
              handleGetLoadPercentage = {this.handleGetLoadPercentage}
              showInterior = {this.state.showInterior}
              currentSeatSelected = {this.state.currentSeatSelected}
              handleLoadInterior = {this.handleLoadInterior}
              handleSelectBillboard = {this.handleSelectBillboard}
              showBullets = {this.state.showBullets}
              currentSceneSelected = {this.state.currentSceneSelected}
              showBulletsInterior = {this.state.showBulletInterior}
              showVideo = {this.state.showVideo}
              handleShowVideo = {this.handleShowVideo}
              handleShowVideoText = {this.handleShowVideoText}
              handleOpenDrag = {this.handleOpenDrag}
              handleIsPlayingAnimation={this.handleIsPlayingAnimation}
              isPlayingAnimation = {this.state.isPlayingAnimation}
              showLigths = {this.state.showLigths}
              showInteriorLights = {this.state.showInteriorLights}
              handleShowLigths = {this.handleShowLigths}
              handleShowInteriorLights = {this.handleShowInteriorLights}
              isTouchScreen = {this.props.isTouchScreen}
              enableAR = {this.state.enableAR}
              download3DModel = {this.state.download3DModel}
            />:null
          }
          {params.lite !== "true" &&
            this.state.openScene ?
            <ExitBtnMobile
              handleCloseCarStudio={this.handleCloseScene}
              openScene = {this.state.openScene}
            />:null
          }
          
          {params.lite !== "true" &&
            <TopMenu
              // handleOpenSidebar = {this.handleOpenSidebar}
              openScene = {this.state.openScene}
              handleMuteSong = {this.handleMuteSong}
              isMuted = {this.state.isMuted}
              handleQuotation = {this.handleQuotation}
              isQuotationOpened = {this.state.isQuotationOpened}
              currentModel = {this.state.currentModelSelected}
              currentCompleteCar = {this.state.currentCompleteCar}
              enableInternalCotizaGlobally = {this.state.enableInternalCotizaGlobally}
            />
          }
          {!this.props.isTouchScreen ?
          <Drag
            openScene = {this.state.openScene}
            showDrag = {this.state.showDrag}
            isPortrait = {true}
          />:
          <DragTablets
            openScene = {this.state.openScene}
            showDrag = {this.state.showDrag}
            isPortrait = {true}
          />}
          {this.state.openScene && params.lite !== "true" ?
            <CurrentCarName
              currentSelectedCar={this.props.currentCarSelected}
            />:null
          }
         
          <CarStudioUIMobile
              openScene = {this.state.openScene}
              currentCarSelected={this.props.currentCarSelected}
              handleTurnOffLigths = {this.handleTurnOffLigths}
              closeAllMenus = {this.state.closeAllMenus}
              resetAllMenus = {this.state.resetAllMenus}
              handleCompleteCar={this.handleCompleteCar}
              handleChangeColor = {this.handleChangeColor}
              handleShowInterior = {this.handleShowInterior}
              handleChangeSeat = {this.handleChangeSeat}
              handleChangeScene = {this.handleChangeScene}
              turnOffLights = {this.state.turnOffLights}
              handleShowBulletsInterior = {this.handleShowBulletsInterior}
              handleShowBullets = {this.handleShowBullets}
              handleShowVideo = {this.handleShowVideo}
              showVideo = {this.state.showVideo}
              handleIsVideoOpened = {this.handleIsVideoOpened}
              handleSelectModel = {this.handleSelectModel}
              handleQuotation = {this.handleQuotation}
              isQuotationOpened = {this.state.isQuotationOpened}
              isPlayingAnimation = {this.state.isPlayingAnimation}
              handleIsPlayingAnimation = {this.handleIsPlayingAnimation}
              handleShowLigths = {this.handleShowLigths}
              handleShowInteriorLights = {this.handleShowInteriorLights}
              handleShowPDF = {this.handleShowPDF}
              currentSceneSelected = {this.state.currentSceneSelected}
              firstLoadedWebParams = {this.state.firstLoadedWebParams}
              handleFirstWebParams = {this.handleFirstWebParams}
              handleAR = {this.handleAR}
              handle3DDownload = {this.handle3DDownload}
              enableInternalCotizaGlobally = {this.state.enableInternalCotizaGlobally}
            />
          <Sidebar
            openSidebar = {this.state.openSidebar}
            currentCarSelected={this.props.currentCarSelected}
            handleOpenSidebar = {this.handleOpenSidebar}
            handleMuteSong = {this.handleMuteSong}
            isMuted = {this.state.isMuted}
            handleQuotation = {this.handleQuotation}
            isQuotationOpened = {this.state.isQuotationOpened}
            currentCompleteCar = {this.state.currentCompleteCar}
            enableInternalCotizaGlobally = {this.state.enableInternalCotizaGlobally}
          />
          {
            <Billboards
              currentCarSelected={this.props.currentCarSelected}
              currentBillboardSelected = {this.state.currentBillboardSelected}
              currentCompleteCar = {this.state.currentCompleteCar}
              handleSelectBillboard = {this.handleSelectBillboard}
            />
          }
          {
            <VideoMobile
              isVideoOpened =  {this.state.isVideoOpened}
              completeCar={this.state.currentCompleteCar}
              handleIsVideoOpened = {this.handleIsVideoOpened}
            />
          }
          {this.state.showVideo ?
            <VideoText
              isVideoOpened = {this.state.showVideo && this.state.showVideoText}
              currentCompleteCar={this.state.currentCompleteCar}
              handleShowVideo = {this.handleShowVideo}
            />:null
          }
          {
            <QuotationMobile
              isQuotationOpened = {this.state.isQuotationOpened}
              currentCarSelected={this.props.currentCarSelected}
              currentModelSelected = {this.state.currentModelSelected}
              currentColorSelected={this.state.currentColorSelected}
              handleQuotation = {this.handleQuotation}
              handleCloseScene = {this.handleCloseScene}
            />
          }
          {
            this.state.openLoadingScreen && this.props.openCarStudio ?
            <LoadingScreenMobile
              handleOpenScene = {this.handleOpenScene}
              openLoadingScreen = {this.state.openLoadingScreen}
              isLocale = {this.state.isLocale}
              currentLoadingPercentage={this.state.currentLoadingPercentage}
              currentLoadingInteriorPercentage = {this.state.currentLoadingInteriorPercentage}
            />:null
          }
          {
            <PDFViewerMenu
              showPDF = {this.state.showPDF}
              handleShowPDF = {this.handleShowPDF}
              currentCarSelected={this.props.currentCarSelected}
              currentModelSelected = {this.state.currentModelSelected}
            />
          }
        </div>
      )
  }
}

export default CarStudioContainerMobile